import React from 'react';
import {
	SimpleShowLayout,
	TextField,
	DateField,
	EmailField,
	BooleanField,
} from 'react-admin';
import { Chip, Stack, Typography } from '@mui/material';

import Show from '../common/views/Show';

const ContactTitle = ({ record }) => {
	return <span>{record ? `${record.full_name} ` : ''}</span>;
};

const TagsField = ({ record }) => {
	if (!record || !record.tags) return <Typography variant="body2">No tags</Typography>;

	const tags = Array.isArray(record.tags) ? record.tags : [];

	return (
		<Stack direction="row" spacing={1} flexWrap="wrap" sx={{ gap: 1 }}>
			{tags.map((tag, index) => (
				<Chip key={index} label={tag} size="small" variant="outlined" />
			))}
		</Stack>
	);
};

const ContactShow = (props) => (
	<Show title={<ContactTitle />} {...props}>
		<SimpleShowLayout>
			<TextField source="id" />
			<TextField source="first_name" label="First Name" />
			<TextField source="last_name" label="Last Name" />
			<EmailField source="email" />
			<TextField source="phone" />
			<TextField source="mobile" />
			<TextField source="company" />
			<TextField source="job_title" label="Job Title" />
			<TextField source="department" />
			<TextField source="contact_type" label="Type" />
			<TextField source="status" />
			<TextField source="source" />
			<BooleanField source="marketing_consent" label="Marketing Consent" />
			<DateField source="last_contact_date" label="Last Contact Date" />
			<TextField source="notes" />
			<TagsField source="tags" />
			<DateField source="created_at" />
			<DateField source="updated_at" />
		</SimpleShowLayout>
	</Show>
);

export default ContactShow;
